// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServices_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/additional_services/remover
 *
 * Wire shape preserved from legacy: `dados: null` — the endpoint signals
 * success purely via the envelope `success` flag and carries no payload
 * (soft-delete: so_additional_service_active = 0).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type AdditionalServices_RemoverResponseDados = null;

export type AdditionalServices_RemoverResponse = ApiResponse<AdditionalServices_RemoverResponseDados>;

registerResponseContract('AdditionalServices_RemoverResponse', {})
